<template>
  <div class="top-nav">

    <div class="sub-header-1"  :style="(image && image != 'undefined') ? 'background-image:url('+image+');background-size:cover;' : ''">
      <div class="title-div">
        <h1>{{ title }} </h1>
        
      </div>
    </div>
    <div class="squares">
      <div class="square">&nbsp;</div>
      <div class="square">&nbsp;</div>
      <div class="square">&nbsp;</div>
    </div>
  </div>
</template>

<script>


  export default {
    props: {
      title: {
        type:String
      },
      image: {
        type:String
      }
    }
  }
</script>


<style scoped>


  .sub-header-1{
    font-size:20px;
    height:300px;
    font-weight:bold;
    text-align:left;
    color:#000;
    text-transform:uppercase;
    filter: grayscale(100%);
    /*background-image:url('../assets/option3-row-3-v2.jpg');*/
    background-image:url('../assets/option3-row-2-v2.jpg');
    letter-spacing: 2px;
    position:absolute;
    z-index:5;
    right:250px;
    left:0;
  }

  .top-nav{
    height:350px;
    text-align:left;
  }

  .title-div{
    height:50px;
    padding-top:13px;
    padding-left:6%;
    background:rgba(255,255,255,0.6);
    margin-top:250px;
  }

  .squares{
    xfloat:left;
    top:225px;
    left:0;
    z-index:500;
    position:absolute;
    right:250px;

  }

  .square{
    display:inline-block;
    xwidth:33.3%;
    height:25px;
    opacity:0.7;
    margin:0;
  }

  .squares .square:nth-child(1){
    background:blue;
    width:50%;
  }

  .squares .square:nth-child(2){
    background:green;
    width:30%;
  }

  .squares .square:nth-child(3){
    background:#000;
    width:20%;
  }

  h1{
    font-size:25px;
    font-weight:bold;
    color:blue;
  }

  @media (max-width: 768px){
    .sub-header-1, .squares{
      right:0px;
    }
  }

</style>
